import React from "react";
import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import { Info } from "phosphor-react";

export interface InfoBannerProps {
  message: string;
  icon?: React.ReactNode;
  className?: string;
  textSize?: BODY_TEXT_SIZES;
  bannerType?: (typeof INFO_BANNER_TYPE)[keyof typeof INFO_BANNER_TYPE];
}

export const INFO_BANNER_TYPE = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  WARNING: "warning",
};

const INFO_BANNER_CLASSES = {
  [INFO_BANNER_TYPE.PRIMARY]: {
    INFO_CLASS: "text-brand",
    BG_CLASS: "bg-brand-lightest",
  },
  [INFO_BANNER_TYPE.SECONDARY]: {
    INFO_CLASS: "text-secondary",
    BG_CLASS: "bg-accent",
  },
  [INFO_BANNER_TYPE.WARNING]: {
    INFO_CLASS: "text-warning",
    BG_CLASS: "bg-warning-lightest",
  },
};

const InfoBanner = ({
  message,
  icon,
  className = "",
  textSize = BODY_TEXT_SIZES.X_SMALL,
  bannerType = INFO_BANNER_TYPE.PRIMARY,
}: InfoBannerProps) => {
  return (
    <div
      className={`w-full flex items-center p-sm mb-4 rounded-lg ${INFO_BANNER_CLASSES[bannerType].BG_CLASS} ${className}`}
    >
      {icon || (
        <Info
          width={16}
          height={16}
          className={`flex-shrink-0 ${INFO_BANNER_CLASSES[bannerType].INFO_CLASS}`}
        />
      )}

      <BodyText size={textSize} className="ml-sm">
        {message}
      </BodyText>
    </div>
  );
};

export default InfoBanner;
